import { render, staticRenderFns } from "./LmNomenclaturasNewOrEdit.vue?vue&type=template&id=4ca5226e&scoped=true"
import script from "./LmNomenclaturasNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmNomenclaturasNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmNomenclaturasNewOrEdit.vue?vue&type=style&index=0&id=4ca5226e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5226e",
  null
  
)

export default component.exports